import { chunkSizes, chunkTypes } from '../chunk';
import PngChunkView from '../chunks/pngChunkView';
import { byteChunksToInt } from '../utils';

export default class BytesToChunksTransformer implements Transformer<Uint8Array, PngChunkView>
{
    private isSignatureArea = true;
    private filledBytes = 0;
    private currentLength: number | undefined = undefined;
    private currentPngChunk: Uint8Array[] = [];

    start()
    {
        this.isSignatureArea = true;
        this.filledBytes = 0;
        this.currentLength = undefined;
        this.currentPngChunk = [];
    }

    transform(
        bytes: Uint8Array,
        controller: TransformStreamDefaultController<PngChunkView>,
    )
    {
        let isBatchProcessed = false;

        while (!isBatchProcessed)
        {
            if (this.isSignatureArea)
            {
                if (
                    this.filledBytes + bytes.byteLength
                    >= chunkTypes.signature.length
                )
                {
                    this.isSignatureArea = false;
                    this.filledBytes = 0;
                    bytes = bytes.subarray(chunkTypes.signature.length);
                }
                else
                {
                    this.filledBytes += bytes.byteLength;
                    isBatchProcessed = true;
                }
            }
            else if (this.currentLength === undefined)
            {
                if (this.filledBytes + bytes.byteLength >= chunkSizes.LENGTH)
                {
                    const lengthBytes = bytes.subarray(0, chunkSizes.LENGTH);

                    this.currentPngChunk.push(lengthBytes);
                    this.filledBytes += chunkSizes.LENGTH;

                    this.currentLength = byteChunksToInt(this.currentPngChunk);
                    bytes = bytes.subarray(chunkSizes.LENGTH);
                }
                else
                {
                    this.currentPngChunk.push(bytes);
                    this.filledBytes += bytes.byteLength;
                    isBatchProcessed = true;
                }
            }
            else
            {
                const chunkSize = chunkSizes.LENGTH
                    + chunkSizes.TYPE
                    + this.currentLength
                    + chunkSizes.CRC;

                const remainingLength = chunkSize - this.filledBytes;

                if (bytes.byteLength >= remainingLength)
                {
                    this.currentPngChunk.push(bytes.subarray(0, remainingLength));
                    const pngChunk = new PngChunkView(this.currentPngChunk);

                    controller.enqueue(pngChunk);

                    bytes = bytes.subarray(remainingLength);
                    this.filledBytes = 0;
                    this.currentPngChunk = [];
                    this.currentLength = undefined;
                }
                else
                {
                    this.currentPngChunk.push(bytes);
                    this.filledBytes += bytes.byteLength;
                    isBatchProcessed = true;
                }
            }
        }
    }

    flush(controller: TransformStreamDefaultController<PngChunkView>)
    {
        if (this.filledBytes > 0)
        {
            controller.error('Unexpected end of stream');
        }
    }
}
